/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Status_Validation_FailedInputs */



/**
* | output |
* | --- |
* | "Validation Failed" |
*
* @param {Api_Keys_Status_Validation_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_keys_status_validation_failed = /** @type {((inputs?: Api_Keys_Status_Validation_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Status_Validation_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Validierung fehlgeschlagen")
	return /** @type {LocalizedString} */ ("Validation Failed")
});